// extracted by mini-css-extract-plugin
export default {"title":"JvxBBKaRIhc_egP5Sggv","report_footer_link":"s4xhEqEt6xy_wJSwawZN"};